import { JSONValue } from '@form-engine/server-application/typings';
import { FormSession } from '../types/form';
import fetchBackend from '@form-engine/core-util/fetch-backend';
import FormEngine from '@form-engine/core-application/index';

export default async function fetchWflBackend(
    formId: string,
    wflId: string,
    session: Partial<FormSession>,
    data?: JSONValue,
    options: RequestInit = {}
) {
    const path = FormEngine.wflBackendRoute
        .replace(':formId', formId)
        .replace(':wflId', wflId);

    return fetchBackend(path, session, data, options) || {} as Partial<FormSession>;
}
